export default __webpack_public_path__ + "54d14ba4679b3eba521a0401c462b048.png";